// extracted by mini-css-extract-plugin
module.exports = {"BreakpointSmall":"400px","portrait":"_31Lh_"};